import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { clone } from 'lodash';
import {
  Button,
  Divider,
  Grid,
  Header,
  Label,
  Segment,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import ProjectUnitActivities from '../../../components/ProjectUnitActivities';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

class Logs extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      isDeveloper: PropTypes.bool,
      isSiteplan: PropTypes.bool,
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
    }),
    data: PropTypes.shape({
      project: PropTypes.shape({
        maOwnerCompanyBranchID: PropTypes.number,
      }),
    }),
    isMobile: PropTypes.bool,
    loading: PropTypes.bool,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  });
  static getPropsToState = (props) => {
    const data = props.data || {};
    return {
      data,
      oriData: clone(data),
    };
  }
  constructor(props) {
    super(props);
    const state = Logs.getPropsToState(props);
    this.state = {
      ...state,
      collapseSegments: [{
        hideActivityLogs: false,
      }],
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = Logs.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  hasAccess(check = false) {
    const user = this.props.auth;
    const { data } = this.state;
    if (user && (user.isHeadquarters || user.isSuperAdmin)) {
      return true;
    }
    if (user && user.isBranchLeader && user.companyBranch &&
      data && data.project &&
      (data.project.maOwnerCompanyBranchID === user.companyBranch.id)
    ) {
      return true;
    }
    return check;
  }
  hasAccessInternal() {
    const auth = this.props.auth;
    if (auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return false;
  }
  handleOnCollapseSegment = (e, { name, value }) => {
    const { collapseSegments } = this.state;
    e.preventDefault();
    collapseSegments[name] = !value;
    this.setState({ collapseSegments });
  }
  render() {
    const { auth, isMobile, loading, t } = this.props;
    const { data } = this.state;
    const { hideActivityLogs } = this.state.collapseSegments;
    return (
      <Grid>
        {
          auth && data && this.hasAccess(this.hasAccessInternal()) && (
            <Grid.Row>
              <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
                <Header
                  className="new_title"
                  as="h5"
                  textAlign="center"
                  attached="top"
                >
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={16} textAlign="center">
                        {t('Activity Logs').toUpperCase()}
                      </Grid.Column>
                      <Label
                        as="button"
                        attached="top right"
                        icon={hideActivityLogs ? 'angle up' : 'angle down' }
                        className="collapse-button"
                        style={{
                          position: 'absolute',
                          right: '0',
                          top: '3px',
                          marginRight: '0',
                          marginTop: '0.5em',
                        }}
                        name="hideActivityLogs"
                        value={hideActivityLogs}
                        onClick={this.handleOnCollapseSegment}
                        disabled={loading}
                      />
                    </Grid.Row>
                  </Grid>
                </Header>
                {
                  !hideActivityLogs ? (
                    <Segment attached>
                      <ProjectUnitActivities
                        data={data.projectUnitActivities || []}
                        hasAccess={auth.isHeadquarters || auth.isSuperAdmin}
                        loading={loading}
                      />
                      <Divider hidden />
                      <Grid.Row>
                        <Grid.Column style={{ textAlign: 'center' }}>
                          {
                            data.projectUnitActivities ?
                              <Button
                                as={Link}
                                to={`/projects/${data.projectID}/units/${data.id}/activities/`}
                                content={t('View More', { ns: TRANSLATION_FILES.translation })}
                              />
                            : null
                          }
                        </Grid.Column>
                      </Grid.Row>
                    </Segment>
                ) : null
                }
              </Grid.Column>
            </Grid.Row>
          )
        }
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(connect(Logs.mapStateToProps)(Logs));



// WEBPACK FOOTER //
// ./src/containers/Project/Unit/Logs.jsx